import dateformat from 'dateformat'
import { format } from 'date-fns'
import { TextLink } from 'baby-design'
import { RegistryDiscount } from 'src/types/registryDiscount'
import { CONFIG } from 'shared/constants'
import css from './RegistryDiscountDetails.styles.scss'
export interface RegistryDiscountDetailsProps {
  isRegistryDiscountRevampEnabled?: boolean
  registryDiscount?: RegistryDiscount
  registryDiscountEndsAt: string
  openModal?: () => void
  isMobile: boolean
}

const LearnMoreLink = ({
  openModal,
  isMobile,
}: {
  openModal?: () => void
  isMobile: boolean
}) => {
  const size = isMobile ? 'xs' : 'md'
  return (
    <TextLink
      underline
      size={size}
      variant="inverted"
      weight="regular"
      onClick={openModal}
    >
      Learn more
    </TextLink>
  )
}

const SingleUseDiscountDetail = ({
  registryDiscountEndsAt,
  isRegistryDiscountRevampEnabled,
  openModal,
  isMobile,
}: RegistryDiscountDetailsProps) => {
  return (
    <div className={css.RegistryDiscountDetails__detail}>
      One time use. Expires{' '}
      {format(new Date(registryDiscountEndsAt), 'M/d/yyyy')}{' '}
      {isRegistryDiscountRevampEnabled && (
        <LearnMoreLink openModal={openModal} isMobile={isMobile} />
      )}
    </div>
  )
}

export const RegistryDiscountDetails = ({
  isRegistryDiscountRevampEnabled,
  registryDiscount,
  registryDiscountEndsAt,
  openModal,
  isMobile,
}: RegistryDiscountDetailsProps) => {
  const eligibleForMultiuseDiscount =
    registryDiscount?.eligibleForMultiuseDiscount
  const eligibilityEndsAt = registryDiscount?.eligibilityEndsAt
  const expirationDate = dateformat(eligibilityEndsAt, 'UTC:mmmm d, yyyy')

  if (isRegistryDiscountRevampEnabled) {
    return (
      <>
        <div className={css.RegistryDiscountDetails__detailHeader}>
          Get {CONFIG.store.registryDiscountPctDisplay} on Babylist Shop Items
        </div>
        {eligibleForMultiuseDiscount ? (
          <div className={css.RegistryDiscountDetails__detail}>
            Use your discount again and again until {expirationDate}{' '}
            <LearnMoreLink openModal={openModal} isMobile={isMobile} />
          </div>
        ) : (
          <SingleUseDiscountDetail
            registryDiscountEndsAt={registryDiscountEndsAt}
            openModal={openModal}
            isRegistryDiscountRevampEnabled={isRegistryDiscountRevampEnabled}
            isMobile={isMobile}
          />
        )}
      </>
    )
  }
  return (
    <>
      <div className={css.RegistryDiscountDetails__detailHeader}>
        {CONFIG.store.registryDiscountPctDisplay} discount on Babylist store
        items
      </div>
      <SingleUseDiscountDetail
        registryDiscountEndsAt={registryDiscountEndsAt}
        isMobile={isMobile}
      />
    </>
  )
}
